module.exports = __webpack_public_path__ + "img/play_hover.303c93d5.png";